import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import './UpdateRouterStep';
import CountDownTimer from '../../../../Shared/CountDownTimer/CountDownTimer';
import {getWizardStep} from '../../routerActivationWizardBlockSlice';
import LocalLoader from '../../../../Shared/LocalLoader/LocalLoader';
import gaParams from '../../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../../utilities/analytics/tracking';

const UpdateRouterStep = (props) => {
  useEffect(() => {
    async function getWizardStep() {
      gaEvent(
        gaParams.ROUTER_ACTIVATION_WIZARD_UPDATE_STEP_DISPLAY.category,
        gaParams.ROUTER_ACTIVATION_WIZARD_UPDATE_STEP_DISPLAY.eventType,
        gaParams.ROUTER_ACTIVATION_WIZARD_UPDATE_STEP_DISPLAY.eventParams,
      );

      const data = {
        RequestId: props.RequestId,
        CurrentStep: props.CurrentStep,
      };
      await props.getWizardStep(data);
    }
    getWizardStep();
  }, []);

  return (
    <div className='update-router-step'>
      <div className='update-router-step-top-circle'>2</div>
      <div className='update-router-step-title'>מעדכנים!</div>
      <div className='update-router-step-text'>
        עכשיו תורנו לעדכן את הנתב.
        <br />
        כמה דקות וממשיכים
      </div>
      <CountDownTimer delegateAction={getWizardStep} />
      <div style={{margin: '40px auto'}}>
        <LocalLoader />
      </div>
      <div className='update-router-step-attention-section'>
        <div style={{display: 'flex'}}>
          <div>
            <Image className='i-icon' src={require('../../images/i-icon/i-icon.svg')} />
          </div>
          <div className='update-router-step-text-small update-router-step-bold'>
            שימו לב!
            <br />
            הקפידו לא לנתק או ללחוץ על כפתורים
            <br />
            בנתב עד לסיום התהליך
          </div>
        </div>
        <div className='update-router-step-text-small'>אם חשבתם להכין קפה. עכשיו יהיה זמן מצוין :)</div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    RequestId: state.RouterActivationWizardBlock.wizardRequestId,
    CurrentStep: state.RouterActivationWizardBlock.currentStep,
  };
};

const mapDispatchToProps = {
  getWizardStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateRouterStep);
